export class CancelledException extends Error {}
